import { computed, Injectable, signal } from "@angular/core";
import { FileStateModel } from "../Dto/FileStateModel";
import { File } from "../Dto/FileModel";
import { PaginationInfo } from "../Dto/SearchFileResponse";
import { SearchFileRequest } from "../Dto/SearchFileRequest";

const initialState: FileStateModel = {
  data: [],
  currentFile: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class FileState {
  private readonly state = signal<FileStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly currentFile = computed(() => this.state().currentFile);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setFiles(data: File[], pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      data,
      pagination,
      loading: false,
      error: null,
    }));
  }

  setCurrentFile(file: File | null): void {
    this.state.update((state) => ({
      ...state,
      currentFile: file,
      loading: false,
      error: null,
    }));
  }

  setSearchParams(params: SearchFileRequest): void {
    this.state.update((state) => ({
      ...state,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error, loading: false }));
  }

  addFile(file: File): void {
    this.state.update((state) => ({
      ...state,
      data: [...state.data, file],
      loading: false,
      error: null,
    }));
  }

  updateFile(file: File): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((f) =>
        (() => {
          if (f.id === file.id) {
            return file;
          }
          return f;
        })(),
      ),
      loading: false,
      error: null,
    }));
  }

  removeFile(fileId: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((f) => f.id !== fileId),
      loading: false,
      error: null,
    }));
  }
}
